import controller from '../../Controller.js';
import Notification from '../Notification/Index.js';
import { getIconMarkup } from '../../Helpers/IconHelper.js';
import CourseSearchData from '../../Analytics/CourseSearchData.js';
import { CoursesStatusUpdater } from '../../Helpers/CoursesStatusUpdater.js';

function ManualFilter(form) {
    var resultContainer;
    var textFieldTimer;
    var request = new XMLHttpRequest();

    function init() {
        if (location.search.indexOf("hidetypefilter") === -1 && document.querySelector("#hideCourseType")) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                searchParams.set("hidetypefilter", document.querySelector("#hideCourseType").getAttribute("value"));

            }
        }
        resultContainer = document.getElementById(form.getAttribute('data-filter-for'));
        resultContainer.setAttribute('aria-live', 'polite');
        var inputs = form.querySelectorAll('input');
        initFilterInputs(inputs);
        updateFilterInputs(inputs);
        updateFiltersCount();
        window.addEventListener('popstate', (e) => {
            var params = new URLSearchParams(location.search);
            fetchFilteredView(params);
            updateFilterInputs(inputs);
        });


        form.addEventListener('submit', (e) => {
            e.preventDefault();
        });


        // Add event to submit button
        var submitButton = form.querySelector('.filter__search-btn');
        if (submitButton) {
            submitButton.addEventListener('click', HandleSubmit);
        }

        form.querySelector('.filter__tags__tag--remove')
            .addEventListener('click',
                (e) => {
                    var url = e.target.dataset.baseurl;
                    if (url === null || url === undefined || url === "") {
                        url = window.location.href.split('?')[0];
                    } else {
                        url = (new URL(url, document.baseURI)).toString();
                    }
                    history.replaceState(null, null, url);

                    fetchFilteredView(new URLSearchParams(location.search), function () {
                        // Run after fetchFilteredView has completed
                        updateCoursesCount();
                        CoursesStatusUpdater();
                    });

                    updateFilterInputs(inputs);
                    updateFiltersCount();
                });
        var datecb = form.querySelector('#date');
        if (datecb) {
            datecb.addEventListener('click', (e) => {
                var dates = document.getElementsByClassName('datetime');
                if (document.getElementById('date').checked) {

                    dates[0].classList.remove('hidden');
                    dates[1].classList.remove('hidden');
                } else {
                    dates[0].classList.add('hidden');
                    dates[1].classList.add('hidden');
                }

            });
        }

        // Register event to clean a filter group
        document.querySelectorAll('.clear-filters').forEach(button => {
            button.addEventListener('click', handleClearFilters);
        });

        // register GTM data for course search
        if (form.dataset.filterFor == 'Courses') {

            // register GTM data on page load
            var gtmData = CourseSearchData(document, false);
            dataLayer.push(gtmData);

            // register GTM data on filter change
            window.addEventListener('ResultUpdated', function () {
                var gtmData = CourseSearchData(document, true);
                dataLayer.push(gtmData);
            }, false);

        }

    }

    function initFilterInputs(inputs) {
        inputs.forEach(input => {
            switch (input.getAttribute('type')) {
                case 'search':
                case 'text':
                    input.addEventListener('keyup', handleTextFieldUpdate);
                    break;
                case 'checkbox':
                case 'radio':
                    if (input.getAttribute('name') === "startandenddatecheckbox") {
                        input.addEventListener('change', function () { handleCheckboxDate(input); });
                        break;
                    }

                    input.addEventListener('change', function () { handleCheckboxUpdate(input); });
                    break;
                case 'date':
                    if (input.getAttribute('name') === "startdate") {
                        input.addEventListener('change', function () { handleDatepickerUpdate(input); });
                        break;
                    }

            }
            input.setAttribute('aria-controls', form.getAttribute('data-filter-for'));
        });

        // Attach event to search field
        var searchInput = document.getElementById('query search');
        if (searchInput) {
            searchInput.addEventListener('keyup', handleTextFieldUpdate);
        }

        // Attach event
        var searchButton = document.getElementById('submit-filter');
        if (searchButton && searchInput) {
            searchButton.addEventListener('click', function () {
                var name = searchInput.name;
                var value = searchInput.value;
                updateSearchParamsAndFetchResult(name, value);
            });
        }

        // Attach events to "ShowAvaliable" checkbox
        var availableInput = document.getElementById('available');
        if (availableInput) {
            availableInput.addEventListener('click', FetchResult);
            availableInput.addEventListener('change', function () { handleCheckboxUpdate(availableInput); });
            availableInput.setAttribute('aria-controls', form.getAttribute('data-filter-for'));
        }


    }

    function updateFilterInputs(inputs) {
        var searchParams = new URLSearchParams(location.search);
        inputs.forEach(input => {
            var name = input.getAttribute('name');
            var value = searchParams.get(name);
            switch (input.getAttribute('type')) {
                case 'search':
                case 'text':
                    input.value = value;
                    break;
                case 'radio':
                case 'checkbox':
                    updateCheckbox(input, value);
                    break;
                case 'date':
                    updateDate(input, value);
                    break;
            }
        });

        var searchInput = document.getElementById('query search');
        if (searchInput) {
            var searchAttrName = searchInput.getAttribute('name');
            searchInput.value = searchParams.get(searchAttrName);

        }


        var availableElement = document.getElementById('available');
        if (availableElement) {
            var availableElementName = availableElement.getAttribute('name');
            var availableElementValue = searchParams.get(availableElementName);
            updateCheckbox(availableElement, availableElementValue);
        }

    }

    function updateDate(input, value) {
        var id = input.getAttribute('id');
        if (id === "startdate") {

            if (value) {
                input.value = value.substring(0, 10);
            } else {
                input.value = "";
            }
        }

        if (id === "enddate") {
            if (value) {
                input.value = value.substring(10, 20);
                var searchParams = new URLSearchParams(window.location.search);
                var previous = searchParams.get(name);
                if (previous) {
                    removeTag(name, previous);
                }

                var sd = document.getElementById('startdate').value;
                addTag(sd + " - " + input.value, "startdate", sd + input.value);
                var datecb = document.getElementById('date');
                datecb.checked = true;
                var dates = document.getElementsByClassName('datetime');
                dates[0].classList.remove('hidden');
                dates[1].classList.remove('hidden');
            } else {
                input.value = "";
            }


        }
        var ed = document.getElementById('enddate').value;

        if (ed == "") {
            var datecb = document.getElementById('date');
            datecb.checked = false;
            var dates = document.getElementsByClassName('datetime');

            dates[0].classList.add('hidden');
            dates[1].classList.add('hidden');

            removeTag("startdate", "");
        }
    }

    function updateCheckbox(input, values) {
        var checked;
        if (values) {
            values.split(',').forEach((value) => {
                if (value == input.value) {
                    checked = true;
                }
            });
        }
        input.checked = checked;
        var tagTitle = input.getAttribute('data-tag');
        var name = input.getAttribute('name');
        if (tagTitle) {
            checked ? addTag(tagTitle, name, input.value) : removeTag(name, input.value);
        }
    }

    function handleClearFilters(e) {

        const filterGroups = e.target.dataset.filterGroup.split(',');
        const groupContainer = document.getElementById(filterGroups[0] + "-filters");

        // Reset checkboxes and radios
        groupContainer.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
            input.checked = false;
        });

        // Clear text inputs
        groupContainer.querySelectorAll('input[type="text"], input[type="date"]').forEach(input => {
            input.value = '';

            UpdateSearchParams(input.getAttribute('name'), '');
        });

        var searchParams = new URLSearchParams(window.location.search);

        filterGroups.forEach(function (item) {
            searchParams.delete(item);
        });

        history.replaceState(null, null, '?' + searchParams.toString());

        updateFiltersCount();

        fetchFilteredView(searchParams);
    }

    function handleTextFieldUpdate(e) {
        updateFiltersCount();
        var name = this.getAttribute('name');
        var value = this.value;
        //If enter, update without delay.
        if (e.keyCode == 13) {
            updateSearchParamsAndFetchResult(name, value);
            return;
        }
        UpdateSearchParams(name, value);
    }

    function handleCheckboxUpdate(e) {
        var name = e.getAttribute('name');
        var checkboxes = document.getElementsByName(name);
        var value = "";
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                if (name === 'semester') {
                    if (document.getElementById('date').checked) {
                        document.getElementById('date').click();
                    }
                }
                value += "," + checkboxes[i].value;
            }
        }
        if (value) value = value.substring(1);

        if (e.getAttribute('data-filter-update')) {
            updateConnectedFilter(e, value);
        }

        if (e.getAttribute('type') == 'radio') {
            var searchParams = new URLSearchParams(window.location.search);
            var previous = searchParams.get(name);
            removeTag(name, previous);
        }

        updateSearchParamsAndFetchResult(name, value);
        var tagTitle = e.getAttribute('data-tag');
        if (tagTitle) {
            e.checked ? addTag(tagTitle, name, e.value) : removeTag(name, e.value);
        }
    }

    function handleCheckboxDate(e) {
        if (e.checked) {
            var checkboxes = document.getElementsByName("semester");
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    checkboxes[i].click();
                }
            }
        } else {
            var datepickers = document.getElementsByName("startdate");
            for (var i = 0; i < datepickers.length; i++) {
                datepickers[i].value = "";
            }
            var searchParams = new URLSearchParams(window.location.search);
            var previous = searchParams.get("startdate");
            if (previous) {
                removeTag("startdate", previous);
                updateSearchParamsAndFetchResult("startdate");
            }
        }
    }

    function HandleSubmit(e) {
        //alert("HANDLE SUBMIT!");
        e.preventDefault();
        FetchResult();
    }

    function handleDatepickerUpdate(e) {

        var start = document.getElementById("startdate").value;
        var end = document.getElementById("enddate").value;

        if (start !== "" && end !== "") {

            var searchParams = new URLSearchParams(window.location.search);
            var previous = searchParams.get("startdate");
            removeTag("startdate", previous);

            addTag(start + " - " + end, "startdate", start + end);
            updateSearchParamsAndFetchResult("startdate", start + end);
        }
    }

    function addTag(title, name, value) {
        //var container = form.querySelector('.filter__tags');
        //if (!container) return;
        //var tag = document.createElement('button');
        //tag.classList.add('filter__tags__tag');
        //tag.setAttribute('data-value', value);
        //tag.setAttribute('data-name', name);
        //tag.innerHTML = title + " " + getIconMarkup('cross');
        //tag.addEventListener('click', (e) => {
        //    var searchParams = new URLSearchParams(window.location.search);
        //    searchParams.delete('page');
        //    //searchParams.delete('hidetypefilter');

        //    var param = searchParams.get(name).split(',');
        //    var nextParam = "";
        //    param.forEach((val) => {
        //        if (val != value) nextParam += ',' + val;
        //    });
        //    if (nextParam) {
        //        searchParams.set(name, nextParam.substring(1));
        //    }
        //    else {
        //        searchParams.delete(name);
        //    }

        //    var inputs = form.querySelectorAll(`input[name="${name}"][value="${value}"]`);
        //    if (name === "startdate") {
        //        inputs = form.querySelectorAll(`input[name="${name}"]`);
        //    }


        //    if (name !== "startdate") {
        //        if (inputs[0].getAttribute('data-filter-update')) {
        //            var connectedContainer = document.getElementById(inputs[0].getAttribute('data-filter-update'));
        //            var connectedInputs = connectedContainer.querySelectorAll('input');
        //            connectedInputs.forEach(input => {
        //                var name = input.getAttribute('name');
        //                searchParams.delete(name);
        //                removeTag(name, input.value);
        //            });
        //            connectedContainer.parentNode.parentNode.classList.add('hidden');
        //        }
        //    }
        //    history.replaceState(null, null, '?' + searchParams.toString());

        //    fetchFilteredView(searchParams);
        //    updateFilterInputs(inputs);

        //    tag.remove();
        //})
        //container.insertAdjacentElement('afterbegin', tag);
    }

    function removeTag(name, value) {
        if (name === "startdate") {
            form.querySelectorAll('.filter__tags__tag').forEach((tag) => {
                if (tag.getAttribute('data-name') === name) {
                    tag.remove();
                }
            });
        }
        form.querySelectorAll('.filter__tags__tag').forEach((tag) => {
            if (tag.getAttribute('data-value') == value && tag.getAttribute('data-name') == name) {
                tag.remove();
            }
        });
    }

    function updateSearchParamsAndFetchResult(name, value) {
        updateFiltersCount();
        UpdateSearchParams(name, value);
        FetchResult(name, value);
    }
    function UpdateSearchParams(name, value){
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('page');
        //searchParams.delete('hidetypefilter');
        if (value) {
            searchParams.set(name, value);
        }
        else {
            searchParams.delete(name);
        }
        history.replaceState(null, null, '?' + searchParams.toString());
    }
    function FetchResult() {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('page');
        //history.replaceState(null, null, '?' + searchParams.toString());

        fetchFilteredView(searchParams, function () {
            // Run after fetchFilteredView has completed
            updateCoursesCount();
            CoursesStatusUpdater();
        });

    }

    function updateFiltersCount() {
        let filterContainer = document.getElementById('filter_form');
        if (!filterContainer) return;

        let checkedCheckboxes = filterContainer.querySelectorAll('input[type="checkbox"]:checked');
        let filtersCountElement = document.getElementById('activeFiltersCount');
        let cleanAllButton = document.getElementById('clean-filter');

        if (filtersCountElement) {
            if (checkedCheckboxes.length > 0) {
                filtersCountElement.innerText = checkedCheckboxes.length.toString();
                filtersCountElement.hidden = false;
                cleanAllButton.hidden = false;
            }
            else {
                filtersCountElement.innerText = "";
                filtersCountElement.hidden = true;
                cleanAllButton.hidden = true;
            }
        }

    }

    function updateCoursesCount()
    {
        //Get courses count
        var coursesElement = document.getElementById("Courses");
        if (!coursesElement) return;
        var coursesCount = coursesElement.dataset.totalCount;

        // Update value
        var coursesCountElement = document.getElementById("CoursesCount");
        if (!coursesCountElement) return;
        coursesCountElement.innerText = coursesCount;
    }

    function fetchFilteredView(searchParams, callback) {
        resultContainer.setAttribute('data-loading', 'true');

        request.abort();
        var url = form.getAttribute('action') + '?' + searchParams.toString();

        request.onreadystatechange = function () {
            if (this.readyState !== 4) return;

            if (this.status === 500) {
                Notification.init('Något gick fel. Vänligen försök igen eller ladda om sidan.', 'error');
                return;
            }

            if (this.status !== 200) return;

            var para = document.createElement('p');
            para.innerHTML = this.responseText;

            if (form.getAttribute("data-filter-for") === "Courses") {
                updateCategories(para);
            }

            window.dispatchEvent(new CustomEvent('FilterUpdate', { detail: searchParams }));

            fetchedFilteredView(para.innerHTML, updateCoursesCount);

            
        };
        request.open('POST', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send();
    }

    function updateCategories(para) {
        var categoryUlHtml = para.querySelector('ul');
        var categoryUlHtmlMobile = para.querySelector('ul.mobile-view');

        if (categoryUlHtml) {
            document.querySelector('.hero__categories ul').innerHTML = categoryUlHtml.innerHTML;
        }
        if (categoryUlHtmlMobile) {
            document.querySelector('ul.mobile-view').innerHTML = categoryUlHtmlMobile.innerHTML;
        }

        var wrap = para.querySelector('.hero__categories.wrap');
        if (wrap) {
            wrap.parentNode.removeChild(wrap);
        }
    }

    function fetchedFilteredView(html, callback) {
        setTimeout(function () {
            resultContainer.removeAttribute('data-loading');
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var element = temp.querySelector('#' + resultContainer.id);
            resultContainer.parentNode.replaceChild(element, resultContainer);
            resultContainer = element;

            window.dispatchEvent(new CustomEvent('ResultUpdated'));

            if (typeof callback === 'function') {
                callback();
            }

            CoursesStatusUpdater();

        }, 200);
    }



    function updateConnectedFilter(input, value) {
        var connectedContainer = document.getElementById(input.getAttribute('data-filter-update'));
        var url = input.getAttribute('data-fetch-url');

        var searchParams = new URLSearchParams(window.location.search);
        var inputs = connectedContainer.querySelectorAll('input');
        inputs.forEach(input => {
            var name = input.getAttribute('name');
            searchParams.delete(name);
            removeTag(name, input.value);
        });

        history.replaceState(null, null, '?' + searchParams.toString());


        var updateFilterRequest = new XMLHttpRequest();
        updateFilterRequest.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status === 500) {
                Notification.init('Något gick fel. Vänligen försök igen eller ladda om sidan.', 'error');
                return;
            }
            if (this.status !== 200) return;
            connectedContainer.innerHTML = this.responseText;
            connectedContainer.parentNode.parentNode.classList.remove('hidden');
            var inputs = connectedContainer.querySelectorAll('input');
            initFilterInputs(inputs);
            updateFilterInputs(inputs);
        };
        updateFilterRequest.open('POST', url, true);
        updateFilterRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        updateFilterRequest.setRequestHeader('Content-Type', 'application/json');
        updateFilterRequest.send(JSON.stringify({ value }));
    }
    return {
        init: init,
    }
}

controller.add('ManualFilter', ManualFilter);

export default ManualFilter;
